import { Minus, Plus } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { parseQuantityInput, stepQuantity } from "../../lib/quantityInput";

// #209: `value === null` ist ein leeres Feld. Der Flow entscheidet, ob er
// ohne Menge bucht (er tut es nie); das Feld springt nicht auf `min` zurück.
// Platzhalter nicht in muted-foreground: das Token erreicht im Dark-Theme
// keine 4,5:1.
export function QuantityStepper({
    value,
    onChange,
    min = 0,
    max = 9999,
    testId = "qty",
    ariaLabel = "Menge",
    placeholder,
}) {
    const bounds = { min, max };
    return (
        <div className="flex items-center gap-2" data-testid={testId}>
            <Button
                type="button"
                variant="outline"
                onClick={() => onChange(stepQuantity(value, -1, bounds))}
                className="pw-tap h-12 w-12 shrink-0 p-0"
                aria-label="minus"
                data-testid={`${testId}-minus`}
            >
                <Minus className="h-5 w-5" />
            </Button>
            <Input
                type="number"
                value={value ?? ""}
                onChange={(e) => onChange(parseQuantityInput(e.target.value, bounds))}
                onFocus={(e) => e.target.select()}
                placeholder={placeholder}
                className="h-14 flex-1 text-center text-2xl font-bold placeholder:text-base placeholder:font-normal placeholder:text-foreground/70"
                inputMode="numeric"
                aria-label={ariaLabel}
                data-testid={`${testId}-input`}
            />
            <Button
                type="button"
                variant="outline"
                onClick={() => onChange(stepQuantity(value, 1, bounds))}
                className="pw-tap h-12 w-12 shrink-0 p-0"
                aria-label="plus"
                data-testid={`${testId}-plus`}
            >
                <Plus className="h-5 w-5" />
            </Button>
        </div>
    );
}
